import React, { useEffect, useRef } from "react";

/**
 * Wrap children with a fade + rise on scroll effect using IntersectionObserver.
 * Uses only CSS classes defined in index.css (.sap-rise / .is-visible).
 */
export default function Reveal({
  as: Tag = "div",
  delay = 0,
  className = "",
  children,
  ...rest
}) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (delay) {
            const t = setTimeout(() => el.classList.add("is-visible"), delay);
            return () => clearTimeout(t);
          }
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  return (
    <Tag ref={ref} className={`sap-rise ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
